export default __webpack_public_path__ + "assets/images/dd0c484be9a72a3201ac9a538effb3f4.svg";